import { render, staticRenderFns } from "./WizardCard.vue?vue&type=template&id=0784a035&scoped=true"
import script from "./WizardCard.vue?vue&type=script&lang=js"
export * from "./WizardCard.vue?vue&type=script&lang=js"
import style0 from "./WizardCard.vue?vue&type=style&index=0&id=0784a035&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0784a035",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0784a035')) {
      api.createRecord('0784a035', component.options)
    } else {
      api.reload('0784a035', component.options)
    }
    module.hot.accept("./WizardCard.vue?vue&type=template&id=0784a035&scoped=true", function () {
      api.rerender('0784a035', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard/WizardCard.vue"
export default component.exports